import type { RolePermissionMap } from '../../utils/rolePermissions';

export function canAccessMenu(rolePermissions: RolePermissionMap, menuId: string, userRole: string): boolean {
  // Normalize user role for consistency
  if (!userRole) return false;
  const normalizedRole = userRole.trim();

  const permissions = rolePermissions[normalizedRole as keyof RolePermissionMap];
  if (!permissions) {
    // Only warn once in dev mode
    if (import.meta.env.DEV) {
      console.warn(`⚠️ No permissions found for role: "${normalizedRole}"`);
    }
    return false;
  }
  return permissions.menus.includes(menuId);
}

export function canUseFeature(rolePermissions: RolePermissionMap, featureId: string, userRole?: string): boolean {
  // Normalize user role for consistency
  if (!userRole) return false;
  const normalizedRole = userRole.trim();

  const permissions = rolePermissions[normalizedRole as keyof RolePermissionMap];
  if (!permissions) {
    return false;
  }
  return permissions.features.includes(featureId);
}
